<template>
	<div class="wrapper">
		<div id="certificate-item" class="certificate">
			<div  class="certificate__wrapper">
				<div class="certificate__header">
					<h5>{{ this.credential.title }}</h5>	
				</div>
				<div class="certificate__body">
					<img class="credential__img" :src="this.credential.document" :alt="this.credential.title" >
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CredentialModal',
	props: {
		credential: {
			type: Object,
			default() {
				return {};
			}
		}
	}
};
</script>

<style lang="scss" scoped>

.wrapper {
	margin: 30px;
}
.certificate {
	display: block;
	font-family: 'Montserrat', sans-serif;
	border: 1px solid $grey-lightest;
	position: relative;
	margin-bottom: 5px;
	border-radius: 4px;
	overflow: hidden;
	background: $white;
	box-shadow: 4px 3px 83px 0px rgba(0,0,0,0.13);
	&__wrapper {
        max-width: 90%;
		margin: auto;
		padding: 20px 30px 30px;
		text-align: center;
	}
	&__header {
		padding-bottom: 20px;
	}
	&__body {
		padding-top: 30px;
	}
}
button {
	height: 40px;
}
.credential {
    &__img {
        width: 100%;
        height: auto;
        margin-left: auto;
        margin-right: auto;
    }
}

</style>
